import { useEffect } from "react";

/**
 * Per-route SEO — sets document.title, meta description, canonical, OG/Twitter tags.
 * Canonical origin resolves at runtime from window.location.origin so the site
 * works correctly under any host (preview, production, custom domain).
 */
export function useSEO({ title, description, path = "", image }) {
  useEffect(() => {
    const origin =
      typeof window !== "undefined" && window.location
        ? window.location.origin
        : "";
    const routePath =
      path ||
      (typeof window !== "undefined" ? window.location.pathname : "");
    const canonical = `${origin}${routePath}`;

    document.title = title;

    const setMeta = (selector, attr, value, createTag) => {
      let el = document.querySelector(selector);
      if (!el && createTag) {
        el = document.createElement(createTag.tag);
        Object.entries(createTag.attrs).forEach(([k, v]) => el.setAttribute(k, v));
        document.head.appendChild(el);
      }
      if (el) el.setAttribute(attr, value);
    };

    setMeta('meta[name="description"]', "content", description, { tag: "meta", attrs: { name: "description" } });
    setMeta('meta[property="og:title"]', "content", title, { tag: "meta", attrs: { property: "og:title" } });
    setMeta('meta[property="og:description"]', "content", description, { tag: "meta", attrs: { property: "og:description" } });
    setMeta('meta[property="og:url"]', "content", canonical, { tag: "meta", attrs: { property: "og:url" } });
    setMeta('meta[property="og:type"]', "content", "website", { tag: "meta", attrs: { property: "og:type" } });
    setMeta('meta[name="twitter:title"]', "content", title, { tag: "meta", attrs: { name: "twitter:title" } });
    setMeta('meta[name="twitter:description"]', "content", description, { tag: "meta", attrs: { name: "twitter:description" } });
    if (image) {
      setMeta('meta[property="og:image"]', "content", image, { tag: "meta", attrs: { property: "og:image" } });
      setMeta('meta[name="twitter:image"]', "content", image, { tag: "meta", attrs: { name: "twitter:image" } });
    }

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path, image]);
}
